import { render, staticRenderFns } from "./solveCompliance.vue?vue&type=template&id=2048e0d7&scoped=true&"
import script from "./solveCompliance.vue?vue&type=script&lang=js&"
export * from "./solveCompliance.vue?vue&type=script&lang=js&"
import style0 from "./solveCompliance.vue?vue&type=style&index=0&id=2048e0d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2048e0d7",
  null
  
)

export default component.exports